import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import { useSearch } from 'react-location';
import { useDelayOperation } from '../modules/datastores/useGetQueuePosition';
import { SurvivorsConversationStore } from '../modules/datastores/useGetSurvivorsConversation';
// import { FederatedLeaveHelproomButton } from './waiting-room/Header';

// import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

// import {EMPTY} from 'rxjs';
// import { Subject } from 'rxjs/internal/Subject';

// import {
//   repeatWhen,
//   scan,
//   switchMap,
//   takeWhile
// } from "rxjs/operators";

// const play$ = new BehaviorSubject(true);
// const repeat$ = new Subject();
// const pause = () => play$.next(false);
// const resume = () => play$.next(true);
// const repeat = () => repeat$.next();
// const timer$ = play$.pipe(
//   switchMap((v) => (v ? interval(1000) : EMPTY)),
//   scan((acc, curr) => (curr ? acc - 1 : acc), 5),
//   takeWhile((v) => v >= 0),
//   repeatWhen(() => repeat$)
// );

export interface TurnArrivedProps {
  captcha_token?: string;
}

const TurnArrived: React.FC<TurnArrivedProps> = (props) => {
  const query = useSearch();
  const { mutateAsync: mutateDelayOperation } = useDelayOperation();
  const messaging_service_key = query['messaging_service_key'] as string;
  const task_sid = query['task_sid'] as string;

  const [open, SetOpen] = useState<boolean>(true);
  //const timer=useObservable();

  // const goToHotlines = () => {
  //   SurvivorsConversationStore.goToHotlines();
  //   SetOpen(false);
  // };

  /**
   * Delay after five mins
   */
  const remindAfterFiveMinutes = () => {
    mutateDelayOperation(
      {
        messaging_service_key,
        task_sid,
        captchaToken: { 'g-recaptcha-response': props?.captcha_token ? props?.captcha_token : '' },
      },
      {
        onSettled: () => {
          SetOpen(false);
          SurvivorsConversationStore.stayedInHelproom();
        },
      }
    );
  };

  return (
    <Dialog open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{'A Support Specialist is ready to chat with you'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          To continue connecting with a specialist, press Connect. If you need more time, you will be able to ask to defer your spot in the queue. Please note, all services here are confidential and
          anonymous. Your phone number will not be recorded, tracked, or saved. To defer the spot 5 minutes Press Remind Me
        </DialogContentText>
        <DialogContentText>{/* Auto Closing In  {timer} */}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {/* <FederatedLeaveHelproomButton button_label="Connect" button_class="" leave_helproom_callback={goToHotlines} /> */}
        <Button onClick={remindAfterFiveMinutes}>Remind After 5 Minutes</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TurnArrived;
